import { FC } from 'react'

import { Typography } from '@mui/material'

import { GREY_BORDER } from 'utils/customizedTheme'

interface IProps {
  text: string
  icon?: any
  hasBackground?: boolean
}

const SectionTitle: FC<IProps> = ({ text, icon, hasBackground=true }) => {
  return (
    <Typography
      variant='h3'
      sx={{
        fontWeight: hasBackground ? '400' : '600',
        fontSize: hasBackground ?  '1rem' : '1.2rem',
        margin: '0',
        marginTop: hasBackground ? '20px' : 0,
        padding: hasBackground ? '7px 15px' : 0,
        marginBottom: hasBackground ? 0 : '20px',
        background: hasBackground ? '#fff' : 'none'
      }}
    >
      {text}
      {icon && icon}
    </Typography>
  )
}
export default SectionTitle
